/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.checkAccountStatus'

export { $nsid }

/** Returns the status of an account, especially as pertaining to import or recovery. Can be called many times over the course of an account migration. Requires auth and can only be called pertaining to oneself. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    activated: l.boolean(),
    validDid: l.boolean(),
    repoCommit: l.string({ format: 'cid' }),
    repoRev: l.string(),
    repoBlocks: l.integer(),
    indexedRecords: l.integer(),
    privateStateValues: l.integer(),
    expectedBlobs: l.integer(),
    importedBlobs: l.integer(),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
